import React from "react";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import SpotlioIcon from "../Icon";

import useLogic from "./useLogic";

import "./index.scss";

const Seasonality = (props) => {
    const { season, updateSeason, checkForSmallerSeasonality, seasonality } = useLogic(props);

    if (checkForSmallerSeasonality()) {
        return (
            <div className="seasons">
                {
                    seasonality.list.map((seas, index) => {
                        return (
                            <div onClick={() => updateSeason(undefined, seas.name)} key={`season_${index}`} className={`season ${seas.name === season.name ? "selected" : ""}`}>
                                <SpotlioIcon icon={seas.icon} />
                                <span>{seas.name}</span>
                            </div>
                        )
                    })
                }
            </div>
            
        )
    }

    return (
        <ToggleButtonGroup 
            className={"seasonToggler"}
            exclusive
            value={season.name} 
            onChange={updateSeason}
        >
            {
                seasonality.list.map(seas => {
                    return (
                        <ToggleButton value={seas.name}>
                            <SpotlioIcon icon={seas.icon} />
                            <span>{seas.name}</span>
                        </ToggleButton>
                    )
                })
            }
        </ToggleButtonGroup>
    )
}

export default Seasonality;